import React from 'react'
import './ShortCard.css'
import {ExternalLink} from 'lucide-react'
import CountUp from 'react-countup';
import SpinningDots from '../../components/Loader/SpinningDots'
import { Link } from 'react-router-dom'
import {translateName} from "../../utils/i18n"

class ShortCard extends React.Component {

    componentDidMount() {
        const { dataFetcher } = this.props
        dataFetcher && dataFetcher()
    }

    componentDidUpdate(prevProps) {
        const { dataFetcher, path } = this.props

        if ( path !== prevProps.path ) {
            dataFetcher && dataFetcher()
        }
    }

    render() {
        const { title = "Title", width, language, data = 0 , link, suffix=" (Nb)", isFetching, subTitle, t} = this.props

        const getContainerClass = () => {
            if(width) return `col-sm-${width} col-md-${width} col-lg-${width}`
            return "col-sm-6 col-md-4 col-lg-4"
        }

        return (
            <div className={`ShortCard-container ${getContainerClass()}`}>
                <div className="ShortCard">
                    <div className="ShortCard-title-section">
                        <h4>{translateName(title, language)}</h4>
                        {
                            subTitle && <div className="ChartCard-subTitle" style={{color: `${subTitle.color}`, font: `${subTitle.font}`}}>{t(subTitle.text, subTitle.data)}</div>
                        }
                    </div>
                    <div className="ShortCard-second-section">
                        <div className="ShortCard-content">
                            {
                                isFetching ? (
                                    <SpinningDots/>
                                ) : <CountUp delay={0.2} start={0} end={data} suffix={suffix} separator=","/>
                            }
                        </div>
                        <div className="ShortCard-link">
                            {
                                link.title && <Link to={link.path}>
                                    <ExternalLink className="ShortCard-icon" size={20}/>
                                </Link>
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default ShortCard
